// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gap-4[data-v-7667e3ae]{gap:16px}.gap-2[data-v-7667e3ae]{gap:8px}.color-box[data-v-7667e3ae]{width:18px;height:18px;display:inline-block;border:1px solid rgba(0,0,0,.2);-webkit-box-shadow:0 1px 3px rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.12);-ms-flex-negative:0;flex-shrink:0}.bg-light[data-v-7667e3ae]{background-color:#f8f9fa}", ""]);
// Exports
module.exports = exports;
